// Import model
import { StartProjectAppointmentCancelAppointmentRequest } from '../models/StartProjectAppointmentCancelAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAppointmentCancelAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAppointmentCancelAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAppointmentCancelAppointmentRequest instance
   */
  static deserialize(json: string): StartProjectAppointmentCancelAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAppointmentCancelAppointmentRequest instance
   */
  static fromObject(obj: any): StartProjectAppointmentCancelAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAppointmentCancelAppointmentRequest');
    }


    const instance: StartProjectAppointmentCancelAppointmentRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAppointmentCancelAppointmentRequest instances
   */
  static deserializeArray(json: string): StartProjectAppointmentCancelAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAppointmentCancelAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAppointmentCancelAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAppointmentCancelAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartProjectAppointmentCancelAppointmentRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of StartProjectAppointmentCancelAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAppointmentCancelAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
